// src/app/meter/services/meter-analytics.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MeterAnalyticsQuery, MeterSnapshotResponse, MeterDistributionResponse, MeterTrendsResponse, MeterGeoResponse } from '../models/meter-analytics.model';

@Injectable()
export class MeterAnalyticsService {
    private baseUrl = `${environment.API_GATEWAY_URL}/iot/admin/analytics`;

    constructor(private http: HttpClient) {}

    getSnapshot(query: MeterAnalyticsQuery): Observable<MeterSnapshotResponse> {
        return this.http.get<MeterSnapshotResponse>(`${this.baseUrl}/snapshot`, {
            params: this.buildParams(query),
        });
    }

    getDistribution(query: MeterAnalyticsQuery): Observable<MeterDistributionResponse> {
        return this.http.get<MeterDistributionResponse>(`${this.baseUrl}/distribution`, {
            params: this.buildParams(query),
        });
    }

    getTrends(query: MeterAnalyticsQuery): Observable<MeterTrendsResponse> {
        return this.http.get<MeterTrendsResponse>(`${this.baseUrl}/trends`, {
            params: this.buildParams(query),
        });
    }

    getGeo(query: MeterAnalyticsQuery): Observable<MeterGeoResponse> {
        return this.http.get<MeterGeoResponse>(`${this.baseUrl}/geo`, {
            params: this.buildParams(query),
        });
    }

    private buildParams(query: MeterAnalyticsQuery): HttpParams {
        let params = new HttpParams();

        if (query.period) {
            params = params.set('period', query.period);
        }
        if (query.from) {
            params = params.set('from', query.from);
        }
        if (query.to) {
            params = params.set('to', query.to);
        }
        if (query.comparePrevious) {
            params = params.set('comparePrevious', 'true');
        }
        if (query.nodeType && query.nodeType.length > 0) {
            query.nodeType.forEach((type) => {
                params = params.append('nodeType', type);
            });
        }
        if (query.postalCode && query.postalCode.length > 0) {
            query.postalCode.forEach((code) => {
                params = params.append('postalCode', code);
            });
        }
        if (query.alertType && query.alertType.length > 0) {
            query.alertType.forEach((type) => {
                params = params.append('alertType', type);
            });
        }

        return params;
    }
}
